$(function () {
    $('[data-graph-axis]').each(function () {
        init(this);
    });

    function init(el) {
        am4core.ready(function () {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create chart
            var chart = am4core.create(el, am4charts.XYChart);
            chart.paddingRight = 20;
            chart.paddingLeft = 0;

            chart.data = generateChartData();

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.baseInterval = {
                "timeUnit": "minute",
                "count": 1
            };
            dateAxis.tooltipDateFormat = "HH:mm, d MMMM";

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            // valueAxis.title.text = "Unique visitors";

            var series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "visits";
            series.tooltipText = "Visits: [bold]{valueY}[/]";
            series.fillOpacity = 0.5;
            series.stroke = am4core.color("#00a2ac");
            series.fill = am4core.color("#00a2ac");

            var fillModifier = new am4core.LinearGradientModifier();
            fillModifier.opacities = [1, 0];
            fillModifier.offsets = [0, 1];
            fillModifier.gradient.rotation = 90;
            series.segments.template.fillModifier = fillModifier;

            series.tooltip.getFillFromObject = false;
            series.tooltip.background.fill = am4core.color("#00a2ac");

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineY.opacity = 0;
            chart.scrollbarX = new am4charts.XYChartScrollbar();
            chart.scrollbarX.series.push(series);

            dateAxis.start = 0.8;
            dateAxis.keepSelection = true;

            var range = valueAxis.axisRanges.create();
            range.value = 130;
            range.endValue = 70;
            range.axisFill.fill = am4core.color("#8BC34A");
            range.axisFill.fillOpacity = 0.5;
            range.grid.strokeOpacity = 0;
            // range.grid.above = true;

            function generateChartData() {
                var chartData = [];
                // current date
                var firstDate = new Date();
                // now set 500 minutes back
                firstDate.setMinutes(firstDate.getDate() - 500);

                // and generate 500 data items
                for (var i = 0; i < 500; i++) {
                    var newDate = new Date(firstDate);
                    // each time we add one minute
                    newDate.setMinutes(newDate.getMinutes() + i);
                    // add data item to the array
                    chartData.push({
                        date: newDate,
                        visits: Math.round(120 - (Math.random() * 70))
                    });
                }
                return chartData;
            }
        }); // end am4core.ready()
    }
});